export function stringToHash(string: string): string {
  return string
    .split(``)
    .reduce((hash, char) => {
      return char.charCodeAt(0) + (hash << 6) + (hash << 16) - hash
    }, 0)
    .toString()
}
